import React, { Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Slider } from "react-burgers";
import AppMobileMenu from "../AppMobileMenu";
import { setEnableClosedSidebar } from "../../reducers/ThemeOptions";

const HeaderLogo = () => {
  const [active, setActive] = useState(false);
  const dispatch = useDispatch();

  const { enableClosedSidebar } = useSelector((state) => ({
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  }));

  /**
   * Toggles the state of the sidebar between open and closed.
   * This function dispatches an action to toggle the `enableClosedSidebar` state
   * in the Redux store. If the sidebar is currently open, it will be closed,
   * and vice versa.
   * @function
   * @returns {void} No return value.
   */
  const toggleEnableClosedSidebar = () => {
    dispatch(setEnableClosedSidebar(!enableClosedSidebar));
  };

  return (
    <Fragment>
      <div className="app-header__logo">
        <a id="link" href="/dashboard">
          <div className="logo-src" />
        </a>
        <div className="header__pane ml-auto">
          <div onClick={toggleEnableClosedSidebar}>
            <Slider
              width={26}
              lineHeight={2}
              lineSpacing={5}
              color="#6c757d"
              active={active}
              onClick={() => setActive(!active)}
            />
          </div>
        </div>
      </div>
      <AppMobileMenu />
    </Fragment>
  );
};

export default HeaderLogo;
